import { render, staticRenderFns } from "./sendToMember.vue?vue&type=template&id=72a4d3fe&"
import script from "./sendToMember.vue?vue&type=script&lang=js&"
export * from "./sendToMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports